export const ADMIN_GET_SETTINGS = 'ADMIN_GET_SETTINGS'
export const ADMIN_UPDATE_SETTINGS = 'ADMIN_UPDATE_SETTINGS'
